import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const EditProfile = () => {
  const [formData, setState] = useState({
    firstName: 'Mustafa',
    lastName: 'Shabbir',
    email: 'mustafashabbir@gmail.com',
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Navigation */}
      <div className="p-6 flex justify-between items-center">
        <div className="flex gap-2 text-sm">
          <Link to="/" className="text-yellow-400">Home</Link>
          <span className="text-gray-400">/</span>
          <span className="text-yellow-400">My Account</span>
        </div>
        <div className="text-yellow-400">Hello Mustafa!</div>
      </div>

      <div className="px-6 flex flex-col lg:flex-row gap-6">
        {/* Sidebar */}
        <div className="lg:w-64">
          <h2 className="text-yellow-400 underline mb-4">Manage My Account</h2>
          <nav className="space-y-2">
            <Link to="/my-orders" className="text-yellow-400 block">My Orders</Link>
            <Link to="/my-profile" className="text-yellow-400 block">My Profile</Link>
          </nav>
        </div>

        {/* Main Content */}
        <div className="flex-1">
          <div className="bg-yellow-400 p-8 rounded-lg">
            <form onSubmit={handleSubmit}>
              <h2 className="text-black text-xl mb-6">Edit Your Profile</h2>

              {/* Name Fields */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-black mb-2">First Name</label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    className="w-full p-3 rounded bg-black text-yellow-400 placeholder-gray-500"
                  />
                </div>
                <div>
                  <label className="block text-black mb-2">Last Name</label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    className="w-full p-3 rounded bg-black text-yellow-400 placeholder-gray-500"
                  />
                </div>
              </div>

              {/* Email Field */}
              <div className="mb-4">
                <label className="block text-black mb-2">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full p-3 rounded bg-black text-yellow-400 placeholder-gray-500"
                />
              </div>

              {/* Password Section */}
              <div className="mb-6">
                <label className="block text-black mb-2">Password Changes</label>
                <div className="space-y-4">
                  <input
                    type="password"
                    name="currentPassword"
                    placeholder="Current Password"
                    value={formData.currentPassword}
                    onChange={handleChange}
                    className="w-full p-3 rounded bg-black text-yellow-400 placeholder-gray-500"
                  />
                  <input
                    type="password"
                    name="newPassword"
                    placeholder="New Password"
                    value={formData.newPassword}
                    onChange={handleChange}
                    className="w-full p-3 rounded bg-black text-yellow-400 placeholder-gray-500"
                  />
                  <input
                    type="password"
                    name="confirmPassword"
                    placeholder="Confirm New Password"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    className="w-full p-3 rounded bg-black text-yellow-400 placeholder-gray-500"
                  />
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex justify-end gap-4">
                <button
                  type="button"
                  className="px-4 py-2 text-black hover:underline"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-6 py-2 bg-black text-yellow-400 rounded hover:bg-gray-900"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;

